import { render, staticRenderFns } from "./ModifierClient.vue?vue&type=template&id=10802a99&scoped=true&lang=true&"
import script from "./ModifierClient.vue?vue&type=script&lang=js&"
export * from "./ModifierClient.vue?vue&type=script&lang=js&"
import style0 from "./ModifierClient.vue?vue&type=style&index=0&id=10802a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10802a99",
  null
  
)

export default component.exports